function NotFound(props) {
  return <h2 className="text-red-700 text-xl text-center py-8 font-bold">404 Page Not Found</h2>
}

export default NotFound;